import { CmsService } from '@/services/cmsService';
import { APP_KEY_ACCESS } from '@/constants/appKeyAccess';

export const parseShortcodes = (shortcodes) =>
  String(shortcodes || '')
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);

export const getAccessTicketFromRoot = (rootElement) =>
  (rootElement.getAttribute('data-access-ticket') || '').trim();

export const resolveAppAccessResult = ({
  result,
  type,
  activeStatus,
  messages,
}) => {
  if (!result?.success || !result?.data) {
    return {
      allowed: false,
      message: messages.requestFailed,
    };
  }

  const normalizedType = String(type || '').trim().toLowerCase();
  const allowedShortcodes = parseShortcodes(result.data?.shortcodes);
  const isStatusActive = Number(result.data?.status) === Number(activeStatus);
  const hasTypeInShortcodes =
    normalizedType.length > 0 && allowedShortcodes.includes(normalizedType);

  if (isStatusActive && hasTypeInShortcodes) {
    return { allowed: true, message: '' };
  }

  return {
    allowed: false,
    message: messages.blocked,
  };
};

export const resolveAppAccessWithDefaultKey = async ({
  type,
  activeStatus,
  messages,
  key,
}) => {
  try {
    const accessKey = key != null ? key : APP_KEY_ACCESS?.defaultKey;
    const fallbackResult = await CmsService.checkAccessKey(accessKey);
    return resolveAppAccessResult({
      result: fallbackResult,
      type,
      activeStatus,
      messages,
    });
  } catch {
    return {
      allowed: false,
      message: messages.requestFailed,
    };
  }
};
